import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  pdf: {
    border: 0,
    display: 'block',
    height: '100%',
    width: '100%'
  }
}));

const ViewPDF = ({ url }) => {
  const classes = useStyles();

  return (
    <object
      className={classes.pdf}
      data={url}
      type="application/pdf"
    />
  );
};

export default ViewPDF;
